module.exports = __webpack_public_path__ + "img/mickey79.b98fc342.jpg";